export default __webpack_public_path__ + "static/media/padlock (1).9c7a0c23.svg";